import React from 'react';
import { connect } from 'react-redux';
import { Modal, Row, Col, Spin, Form} from 'antd';

import { Select, Input } from 'antd';
import { actions, asyncUpdate, asyncAdd, asyncGet } from './reducers';
import { formItemLayout, formatFormData } from './utils';
const FormItem = Form.Item;
const { TextArea } = Input;

class Edit extends React.Component {
    handleCancel = () => {
        this.props.form.resetFields();
        this.props.modalHide();
        this.props.changeCurrentSelectId();
    };
    handleOk = () => {
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                for (let i in values) {
                    if (!values[i]) {
                        delete values[i];
                    }
                }
                if (this.props.item._id === undefined) {
                    await this.props.asyncAdd(formatFormData(values));
                } else {
                    values["_id"] = this.props.item._id;
                    await this.props.asyncUpdate(formatFormData(values));
                }
                this.props.form.resetFields();
                this.props.modalHide();
                this.props.changeCurrentSelectId();
                this.props.asyncGet();
            } else {
                console.log(err);
            }
        });
    };

    render() {
        const { isModalShow, isLoading, item } = this.props;
        const { getFieldDecorator } = this.props.form;
        const {pricpleList} = this.props;
        const pricpleOptin = pricpleList.map(item => {
            return (
                <Option key={item} value={item}>
                    {item}
                </Option>
            );
        });
        const form = (
            <Form>
                <Row>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="eId">
                            {getFieldDecorator('eId', {
                                initialValue: item.eId,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入广告id ',
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }}  />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="ps">
                            {getFieldDecorator('ps', {
                                initialValue: item.ps ,
                                rules: [
                                    {
                                        required: false,
                                        message: '请输入整数',
                                        pattern: /^\d+$/,
                                    },
                                ],
                            })(
                                <Input placeholder="请填写" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="taskType">
                            {getFieldDecorator('taskType', {
                                initialValue: item.taskType,
                            })(
                               // <Input placeholder="请填写" style={{ width: '100%' }} />,
                                <Select>
                                    <Option value="EV">曝光</Option>
                                    <Option value="CLICK">点击</Option>
                                    <Option value='APPLAUNCH'>APP拉起</Option>
                                    <Option value='COMBINE_EV_CLICK'>合并</Option>
                                    <Option value='APP_RETAIN'>注册留存</Option>
                                </Select>,
                            )}
                        </FormItem>
                    </Col>

                    <Col span={24}>
                        <FormItem {...formItemLayout} label="责任人">
                            {getFieldDecorator('pricple', {
                                initialValue: item.pricple ,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入责任人',
                                    },
                                ],
                            })(
                               // <Input placeholder="请填写" style={{ width: '100%' }} />,
                                <Select allowClear placeholder="全部" style={{ width: 160 }}>
                                    {pricpleOptin}
                                </Select>,
                            )}
                        </FormItem>
                    </Col>
                    <Col span={24}>
                        <FormItem {...formItemLayout} label="备注">
                            {getFieldDecorator('notes', {
                                initialValue: item.notes,
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入备注',
                                    },
                                ],
                            })(
                                <TextArea rows={15} placeholder="请填写备注" style={{ width: '100%' }} />,
                            )}
                        </FormItem>
                    </Col>
                </Row>
            </Form>
        );

        return (
            <span>
                <Modal
                    width={800}
                    title="修改"
                    visible={isModalShow}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    confirmLoading={isLoading}
                    maskClosable={false}
                    okText="确定"
                    cancelText="取消">
                    <Spin spinning={isLoading} tip="保存中...">
                        {form}
                    </Spin>
                </Modal>
            </span>
        );
    }
}

const mapStateToProps = state => ({
    item: state.taskNotes.list.reduce((a, b) => (b._id === state.taskNotes.currentSelectId ? b : a), {}),
    isModalShow: state.taskNotes.uiStatus.isUpdateShow,
    isLoading: state.taskNotes.uiStatus.isLoading,
    pricpleList: state.taskNotes.pricpleList,
});

const mapDispatchToProps = dispatch => ({
    modalHide: () => dispatch(actions.changeUiStatus({ isUpdateShow: false })),
    asyncUpdate: contents => dispatch(asyncUpdate(contents)),
    asyncAdd: contents => dispatch(asyncAdd(contents)),
    asyncGet: () => dispatch(asyncGet()),
    changeCurrentSelectId: () => dispatch(actions.changeCurrentSelectId('')),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create()(Edit));



// WEBPACK FOOTER //
// ./pages/sign/taskNotes/edit.js